module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumb"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-658c3671!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/breadcrumb/Breadcrumb.vue
// module id = 343
// module chunks = 0